import * as React from 'react'

function PinActive(props) {
    return (
        <svg
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 73 92"
            {...props}>
            <circle
                cx={36.5}
                cy={36.5}
                r={34}
                fill="#fff"
                stroke="#f73c39"
                strokeWidth={5}
            />
            <text 
                x="50%"
                y="40%" 
                textAnchor="middle" 
                stroke="#f73c39" 
                strokeWidth="2px"
                dy=".3em">
                    {props.number}
            </text>
            <path
                d="M36 73v15.5"
                stroke="#f73c39"
                strokeWidth={6}
                strokeLinecap="round"
            />
        </svg>
    )
}

export default PinActive
